module.exports = __webpack_public_path__ + "img/heart_3_bj.405d114e.png";